import {
    defineComponent
} from 'vue'

import {
    translateToSpanishToGestorImpuestos
} from '@/common/permisos-sindicales/requests/states'

export default defineComponent ({
    name: 'SingleTable'
    , props: {
        fields: {
            type: Array
            , required: false
            , default: () => ([])
        }
        , items: {
            type: Array
            , required: false
            , default: () => ([])
        }
    }
    , methods: {
        translateState (state) {
            return translateToSpanishToGestorImpuestos({ state })
        }
    }
})